var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconImageSquare = function SvgIconImageSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.875 8.625a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21.25 19.5v-15a1.75 1.75 0 0 0-1.75-1.75h-15A1.75 1.75 0 0 0 2.75 4.5v15c0 .966.784 1.75 1.75 1.75h15a1.75 1.75 0 0 0 1.75-1.75M4.75 4.75v9.336l1.506-1.507a1.75 1.75 0 0 1 2.488 0l1.756 1.757 4.006-4.007a1.75 1.75 0 0 1 2.488 0l.003.004 2.253 2.253V4.75zm2.75 9.414-2.75 2.75v2.336h14.5v-3.836l-3.5-3.5-4.006 4.007a1.75 1.75 0 0 1-2.488 0z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconImageSquare;